// extracted by mini-css-extract-plugin
export default {"container":"AddLanguage_container__oB+P-","heading":"AddLanguage_heading__iXkQD","form":"AddLanguage_form__gQIA5","buttonContainer":"AddLanguage_buttonContainer__KNaxp"};